export default "__VITE_ASSET__678f6953__"